import { createAction } from '@reduxjs/toolkit';

export const requestViewStaff = createAction('user-role/viewStaff');
export const requestUpdateUserGroups = createAction('user-role/updateUserGroups');
export const requestPopulateDropdowns = createAction('user-role/populateDropdowns');
